<template>
    <div class="comContent">
        <div class="expand-form">
            <div style="width: 100%; " class="flex-box al-center">
                <div>
                    {{ details.name }}
                </div>
                <div>
                    <el-button v-if="[0, 1, 3].includes(details.status)" size="small" type="primary"
                        @click="create({}, 'create')" key="create" >新建</el-button>
                    <el-button size="small" type="plain" @click="goBack()">返回</el-button>
                </div>
            </div>
        </div>
        <div class="list-body">
            <el-tabs class="tabs-box" v-model="activeName">
                <el-tab-pane v-for="item of tabs" :label="item.label" :name="item.name" :key="item.name">
                    <component :ref="item.name" :is="item.name" :isEdit="isEdit"></component>
                </el-tab-pane>
            </el-tabs>
        </div>
        <CreateGoodsRules ref="CreateGoodsRules" @refresh="refresh" :goodsFrom="details.goodsFrom" />
    </div>
</template>
<script>
import searchForm from "./component/searchForm.vue";
import myTable from "@/components/myTable";
import CreateGoodsRules from "./component/createGoodsRules.vue";
import activityGoodsList from "./component/activityGoodsList";
import rulesList from "./component/rulesList"
import {
    activityDetails,
} from "@/api/platActivityManage";

// 平台活动商品
export default {
    components: { searchForm, myTable, CreateGoodsRules, activityGoodsList, rulesList },
    props: {},
    data() {
        return {
            id: '',
            activeName: 'activityGoodsList',
            tabs: [
                {
                    label: '商品列表',
                    name: 'activityGoodsList'
                },
                {
                    label: '规则列表',
                    name: 'rulesList'
                }
            ],
            details: {
                goodsFrom:0,
                name: '',
                status: '0' // 0草稿1待开始2已停止 3进行中 4已结束")
            }
        };
    },
    filters: {
    },
    created() {
        if (this.$route.query.id) {
            this.id = this.$route.query.id;
            this.activityDetails();
        }
    },
    computed:{
        isEdit(){
            return [0,1,3].includes(this.details.status)
        }
    },
    watch: {
        activeName: {
            handler(activeName) {
                this.$nextTick(() => {
                    this.$refs[activeName][0].onSearch()
                })
            },
            immediate: true
        }
    },
    mounted() { },
    methods: {
        // 刷新列表
        refresh() { 
            this.$refs[this.activeName][0].resetForm()
        },
        activityDetails() {
            activityDetails(this.id).then((res) => {
                if (res && res.id) {
                    this.details = res;
                }
            });
        },
        // 新建
        create(row) {
            this.$refs['CreateGoodsRules'].init({}, 'create');
        },
        goBack() {
            this.$router.back(-1)
        }
    },
};
</script>
<style lang="scss" scoped>
.tabs-box {
    height: 100%;

    ::v-deep {
        .el-tabs__content {
            height: calc(100% - 56px);
        }

        .el-tab-pane {
            height: 100%;
        }

        .el-tabs__header {
            line-height: 45px;
        }
    }
}

.comContent {
    display: flex;
    flex-direction: column;
}

.expand-form {
    margin-top: 24px;
    display: flex;
    justify-content: space-between;
}

.list-body {
    flex: 1;
    height: 0;
}

.flex-box {
    display: flex;
    justify-content: space-between;

    &.al-center {
        align-items: center;
    }
}
</style>
  